module.exports = __webpack_public_path__ + "static/media/giftsReceived_25_50.9bff4574.png";